import importEService from './components/importEService.vue';

export default {
  routes: [
    {
      path: '/',
      component:importEService,
      name:'importEService'
    },
  ]
};
